let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bXavZ")).then(() => parcelRequire('ijb8R'));